<!--
 * @Author: lan.h
 * @Date: 2022-04-18 14:20:55
 * @LastEditors: lan.h
 * @LastEditTime: 2022-05-10 17:24:36
 * @Description: 信息收集表单
-->
<template>
  <div class="contact">
    <div class="header">
      <img :src="$store.state.static_img_url+'pic/logo-vcbeat.png?v='+ $store.state.version">
    </div>
    <div class="content">
      <div v-if="formItem.channelTag == '7'">
        <h1>动脉网V+入群表单</h1>
        <p class="desc" >填下以下资料，即刻加入动脉网V+专家交流群，获取企业品牌营销、生态合作、融资对接交流机会</p>
      </div>
      <div  v-else>
        <h1>填写资料，我们将在24小时内联系您</h1>
        <p class="desc">想要深入了解动脉网产品服务，欢迎填写以下资料，动脉网V+助手将第一时间为您服务</p>
      </div>
      <div class="form">
        <Form ref="formcontact" :model="formItem" :rules="ruleInline" label-position="top" >
          <FormItem label="姓名" prop="name">
            <Input v-model="formItem.name" placeholder="请填写您的姓名"></Input>
          </FormItem>
          <FormItem label="电话" prop="phone">
            <Input v-model="formItem.phone" placeholder="请填写您的电话"></Input>
          </FormItem>
          <FormItem label="所在机构" prop="institute">
            <Input v-model="formItem.institute" placeholder="请填写您的所在机构"></Input>
          </FormItem>
          <FormItem label="职务" prop="duties">
            <Input v-model="formItem.duties" placeholder="请填写您的职务"></Input>
          </FormItem>
          <FormItem label="所在省份" prop="province">
            <Select v-model="formItem.province" placeholder="请选择您所在的省份">
              <Option v-for="item in address" :key="item.id" :value="item.id + ''">{{item.name}}</Option>
            </Select>
          </FormItem>
          <FormItem label="您是否想要了解动脉网提供的服务" prop="is_needs" v-if="formItem.channelTag == '7'">
            <RadioGroup v-model="formItem.is_needs" @on-change="needsChange"> 
              <Radio label="1">是的，想了解一下</Radio>
              <Radio label="2">暂无需求，先进群了解下</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="您在行业中的领域是" prop="area" v-if="(formItem.is_needs == '1' && formItem.channelTag == '7') || formItem.channelTag != '7'">
            <div v-if="is_serviceNeeds_tip && formItem.area" class="serviceNeeds ivu-form-item-error-tip">请选择或填写您的需求</div>
            <RadioGroup v-model="formItem.area" @on-change="areaChange">
              <Radio :label="item.id" v-for="item, index in area" :key="index">{{item.name}}</Radio>
            </RadioGroup>
            <CheckboxGroup v-model="formItem.serviceNeeds" v-if="formItem.area"  @on-change="serviceNeedsChange">
              <Checkbox :label="item.id" v-for="item in area[areaIndex].arr" :key="item.id">{{item.desc}}</Checkbox>
            </CheckboxGroup>
            <div class="other" v-if="formItem.area">
              <p>其他需求</p>
              <Input v-model="formItem.otherNeeds" @on-change="serviceNeedsChange" type="textarea" placeholder="请填写您的个性化需求" :autosize="{minRows: 4,maxRows: 8}" />
            </div>
          </FormItem>
        </Form>
      </div>
      <div class="form-footer">
        <Button :loading="button_loading" class="a" @click="handleSubmit()">
          <span v-if="!button_loading">提交</span>
          <span v-else>提交中</span>
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import {contact_mixins} from 'js/form_mixins'
export default {
  mixins: [contact_mixins],
  created() {
    this.getMeta()
    if('type' in this.$route.query){
      this.formItem.channelTag = this.$route.query.type
    }
  }
}
</script>

<style lang="stylus" scoped>
.contact
  background #fff
  width 1000px
  margin 40px auto 50px
  padding 0 150px
  .header
    padding 20px 0
    border-bottom 1px solid #EEEEEE
    display flex 
    justify-content center
    img 
      height 36px
  .content
    h1 
      text-align center
      font-size 16px
      font-weight 500
      color #333333
      margin-top 20px
      line-height 1
    .desc
      font-size 14px
      color #999999
      margin-top 15px
      text-align center
      line-height 1
    .form
      padding 0 50px
      margin-top 30px
      >>>.ivu-form
        .ivu-form-item-error-tip
          width 100% 
          text-align right
          top -30px
          color #fc3b3b
        //输入框
        .ivu-input
          height 40px
          border-color #DCDFE6
          padding 7px 20px 
          &:focus
            box-shadow none
            border-color #aaa
        .ivu-form-item-error 
          .ivu-input
            border 1px solid #FA7A50
        //单选
        .ivu-radio-wrapper
          margin-right 50px
          .ivu-radio-inner
            width 16px
            height 16px
            border-color #aaa
          .ivu-radio-checked 
            .ivu-radio-focus 
              box-shadow none
            .ivu-radio-inner
              border-color #FA7A50
              &:after
                background-color #FA7A50
                // width 8px
                // height 8px
                // left 3px
                // top 3px
                border-radius 50%
          &:last-child
            margin-right 0
        .ivu-radio-wrapper-checked
          color #FA7A50
        //多选
        .ivu-checkbox-group-item
          width 100%
          display flex
          margin-top 25px
          line-height 22px
          .ivu-checkbox
            margin-right 15px
            .ivu-checkbox-inner
              top 4px
              width 14px
              height 14px
          .ivu-checkbox+span, .ivu-checkbox-wrapper+span
            flex 1
          .ivu-checkbox-checked 
            .ivu-checkbox-inner
              border-color #FA7A50
              background-color #FA7A50
            .ivu-checkbox-inner:after
              top 1px
              left 4px
          .ivu-checkbox-focus
            box-shadow none
        .ivu-checkbox-wrapper-checked
          color #FA7A50
        //select
        .ivu-select-selection-focused, .ivu-select-selection:hover
          border-color #aaa
        .ivu-select-visible 
          .ivu-select-selection
            border-color #aaa
            box-shadow none
        .ivu-select-single 
          .ivu-select-selection
            height 40px
            .ivu-select-selected-value 
              height 40px
              line-height 40px
              padding-left 20px
            >div
              .ivu-select-placeholder
                height 40px
                line-height 40px
                padding-left 20px
        .other
          margin-top 20px
  .form-footer
    border-top 1px solid #EEEEEE 
    padding 30px 0
    display flex 
    justify-content center
    .a
      width 120px
      height 36px
      background #FA7A50
      border-radius 4px
      font-size 14px
      font-weight 500
      color #FFFFFF
      text-align center 
      line-height 36px
      border 0
      &:hover
        background: #f7a084
        transition all 0.5s
      &:focus
        box-shadow: none
</style>